import { Global } from '../../Global';

export class URLUtils {
  static skapaWFSUrl(objektId: string): string {
    return (
      Global['wfsHost'] +
      '?VERSION=1.3.0' +
      '&SERVICE=WFS' +
      '&srsName=EPSG:3006' +
      '&typeName=Fastighetsytor_WFS,metria:rattighet_ga_yta,metria:rattighet_ga_idpunkt,metria:rattighet_ga_linje,metria:rattighet_ga_punkt' +
      '&outputFormat=json' +
      '&count=100' +
      '&REQUEST=GetFeature&' +
      'cql_filter=objekt_id=%27' +
      objektId +
      '%27'
    );
  }

  static skapaCirkelURL(
    eKoord: number,
    nKoord: number,
    radie: number,
    buffertRadie: string
  ) {
    const totalRadie =
      buffertRadie === ''
        ? Math.round(radie)
        : Math.round(radie) + parseInt(buffertRadie);

    return (
      Global['wfsHost'] +
      '?VERSION=1.3.0' +
      '&SERVICE=WFS' +
      '&srsName=EPSG:3006' +
      '&typeName=Fastighetsytor_WFS,metria:rattighet_ga_yta,metria:rattighet_ga_begranslinje,metria:rattighet_ga_idpunkt,metria:rattighet_ga_linje,metria:rattighet_ga_punkt' +
      '&outputFormat=json' +
      '&count=500' +
      '&REQUEST=GetFeature&' +
      'cql_filter=DWITHIN(geom,POINT(' +
      nKoord +
      ' ' +
      eKoord +
      '),' +
      totalRadie +
      ',meters)'
    );
  }

  static skapaLinjeURL(buffertRadie: string, flatCoords: number[]) {
    const radie = this.getBuffertRadie(buffertRadie);
    const lineString = this.formatFlatCoordsToURL(flatCoords);

    return (
      Global['wfsHost'] +
      '?VERSION=1.3.0' +
      '&SERVICE=WFS' +
      '&srsName=EPSG:3006' +
      '&typeName=Fastighetsytor_WFS,metria:rattighet_ga_yta,metria:rattighet_ga_begranslinje,metria:rattighet_ga_idpunkt,metria:rattighet_ga_linje,metria:rattighet_ga_punkt' +
      '&outputFormat=json' +
      '&count=500' +
      '&REQUEST=GetFeature&' +
      'cql_filter=DWITHIN(geom,SRID=3006;LINESTRING(' +
      lineString +
      '),' +
      radie +
      ',meters)'
    );
  }

  static skapaPolygonURL(buffertRadie: string, flatCoords: number[]) {
    const radie = this.getBuffertRadie(buffertRadie);
    const polygonString = this.formatFlatCoordsToURL(flatCoords);

    return (
      Global['wfsHost'] +
      '?VERSION=1.3.0' +
      '&SERVICE=WFS' +
      '&srsName=EPSG:3006' +
      '&typeName=Fastighetsytor_WFS,metria:rattighet_ga_yta,metria:rattighet_ga_begranslinje,metria:rattighet_ga_idpunkt,metria:rattighet_ga_linje,metria:rattighet_ga_punkt' +
      '&outputFormat=json' +
      '&count=500' +
      '&REQUEST=GetFeature&' +
      'cql_filter=DWITHIN(geom,SRID=3006;POLYGON((' +
      polygonString +
      ')),' +
      radie +
      ',meters)'
    );
  }

  private static formatFlatCoordsToURL(flatCoords: number[]) {
    let lineString = '';
    for (let i = 0; i < flatCoords.length; i++) {
      if (i === 0) {
        lineString += flatCoords[i];
      } else {
        if (i % 2 === 0) {
          lineString += ',' + flatCoords[i];
        } else {
          lineString += ' ' + flatCoords[i];
        }
      }
    }
    return lineString;
  }

  private static getBuffertRadie(buffertRadie: string) {
    return buffertRadie === '' ? '0' : buffertRadie;
  }
}
